//#region IMPORT
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import M_Master_BASIC from './M_Master_BASIC';
//#endregion

function M_Master_BASICF() {
  //#region 변수
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  //#endregion

  //#region 이벤트
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업중지'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion

  return (
    <div className="wrap">
      <M_Master_BASIC activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}

export default M_Master_BASICF;
